import { ScreenContainerControl } from "doshx_controls_web";
import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactMarkdown from "react-markdown";
import { useDispatch } from "react-redux";
import { Button } from "@heroui/react";
import { client_terms } from "../../api/calls/client/terms";
import { setMainModal, setContentModal } from "../../reducers/slices/main";
import { NoContentMessage } from "../../components/no_content_message";
import { Shimmer } from "../../components/shimmer/shimmer";
import { ParagraphShimmer } from "../../components/shimmer/shimmer_types";
export const TermsAndConditions = ({ onAccept, showAcceptButton = false }) => {
    const dispatch = useDispatch();
    const [termsData, setTermsData] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
    const [contentFitsViewport, setContentFitsViewport] = useState(false);
    const scrollContainerRef = useRef(null);
    const contentRef = useRef(null);
    useEffect(() => {
        client_terms().then((response) => {
            if (response.success) {
                setIsLoading(false);
                setTermsData(response.content.terms);
            }
            else {
                setIsLoading(false);
                dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
            }
        });
    }, []);
    // Check if content fits viewport (no scroll needed)
    useEffect(() => {
        if (!isLoading && termsData && scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const hasScroll = container.scrollHeight > container.clientHeight;
            if (!hasScroll) {
                setContentFitsViewport(true);
                setHasScrolledToBottom(true);
            }
        }
    }, [isLoading, termsData]);
    // Handle scroll to detect when user reaches bottom
    const handleScroll = useCallback(() => {
        if (scrollContainerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 20; // 20px threshold
            if (isAtBottom) {
                setHasScrolledToBottom(true);
            }
        }
    }, []);
    const handleAccept = () => {
        if (onAccept) {
            onAccept();
        }
        dispatch(setContentModal(null));
    };
    const canAccept = hasScrolledToBottom || contentFitsViewport;
    return (React.createElement("div", { className: "flex flex-col h-full" },
        React.createElement("div", { ref: scrollContainerRef, onScroll: handleScroll, className: "flex-1 overflow-y-auto max-h-[60vh]" },
            React.createElement(ScreenContainerControl, null, isLoading ? (React.createElement("div", { className: "flex flex-col py-6 gap-6 w-full" },
                React.createElement(Shimmer, { width: "60%" }),
                React.createElement(ParagraphShimmer, null),
                React.createElement(ParagraphShimmer, null),
                React.createElement(ParagraphShimmer, null))) : !isLoading && !termsData ? (React.createElement(NoContentMessage, { messages: ["No Terms & Conditions found."], backgroundColour: "bg-white" })) : (React.createElement("div", { ref: contentRef, className: "flex flex-col py-6 gap-4" },
                React.createElement(ReactMarkdown, null, termsData))))),
        showAcceptButton && !isLoading && termsData && (React.createElement("div", { className: "flex flex-col gap-2 pt-4 border-t border-neutral-gray" },
            !canAccept && React.createElement("div", { className: "text-center text-sm text-dark-gray" }, "Please scroll to the bottom to continue"),
            React.createElement(Button, { color: "primary", size: "lg", fullWidth: true, radius: "lg", isDisabled: !canAccept, onPress: handleAccept, className: !canAccept ? "opacity-50" : "" }, "I have read and accept the Terms & Conditions")))));
};
